import { SchemaType } from '../type';
export const schema = {
    id: 'plugin',
    name: get => `插件（${get('pluginId')}）`,
    type: SchemaType.Indivisible,
};
